import { createI18n } from 'vue-i18n'
import { extractLocaleMessages, SUPPORTED_LOCALES, type SupportedLocale } from './utils'

// 從統一的翻譯結構中提取各語系的翻譯
const messages: Record<SupportedLocale, Record<string, any>> = {} as any

SUPPORTED_LOCALES.forEach(locale => {
  messages[locale] = extractLocaleMessages(locale)
})

export const i18n = createI18n({
  legacy: false,
  locale: 'zh-TW',
  fallbackLocale: {
    'zh': ['zh-TW', 'zh-CN', 'en'],
    'zh-CN': ['zh-TW', 'en'],
    'zh-TW': ['en'],
    'en': ['zh-TW'],
    'hi': ['en', 'zh-TW'],
    'ja': ['en', 'zh-TW'],
    'ko': ['en', 'zh-TW'],
    'default': ['zh-TW', 'en']
  },
  messages,
  silentTranslationWarn: true, // 關閉翻譯警告，避免干擾
  numberFormats: {
    'zh-TW': { currency: { style: 'currency', currency: 'TWD' } },
    'zh-CN': { currency: { style: 'currency', currency: 'CNY' } },
    'en': { currency: { style: 'currency', currency: 'USD' } },
    'hi': { currency: { style: 'currency', currency: 'INR' } },
    'ja': { currency: { style: 'currency', currency: 'JPY' } },
    'ko': { currency: { style: 'currency', currency: 'KRW' } }
  },
  datetimeFormats: {
    'zh-TW': { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    'zh-CN': { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    'en': { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    'hi': { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    'ja': { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    'ko': { short: { year: 'numeric', month: 'short', day: 'numeric' } }
  }
})

export default i18n 